var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2.75293C18.2449 2.75296 18.4813 2.84289 18.6644 3.00565C18.8474 3.1684 18.9643 3.39268 18.993 3.63593L19 3.75293V7.75293C19 7.99786 18.91 8.23427 18.7473 8.4173C18.5845 8.60034 18.3603 8.71727 18.117 8.74593L18 8.75293H15V9.75293H18C18.1424 9.75298 18.2831 9.78343 18.4127 9.84223C18.5423 9.90104 18.6579 9.98684 18.7517 10.0939C18.8456 10.201 18.9154 10.3268 18.9567 10.4631C18.998 10.5993 19.0096 10.7428 18.991 10.8839L18.971 10.9959L17.971 14.9959C17.9214 15.1934 17.8126 15.3711 17.6593 15.5051C17.506 15.6391 17.3154 15.7232 17.113 15.7459L17 15.7529H15V21.7529C15 21.9979 14.91 22.2343 14.7473 22.4173C14.5845 22.6003 14.3603 22.7173 14.117 22.7459L14 22.7529H10C9.75507 22.7529 9.51866 22.663 9.33563 22.5002C9.15259 22.3375 9.03566 22.1132 9.007 21.8699L9 21.7529V15.7529H7C6.75507 15.7529 6.51866 15.663 6.33563 15.5002C6.15259 15.3375 6.03566 15.1132 6.007 14.8699L6 14.7529V10.7529C6.00003 10.508 6.08996 10.2716 6.25272 10.0886C6.41547 9.90552 6.63975 9.78859 6.883 9.75993L7 9.75293H9V8.75293C8.99994 7.20055 9.60157 5.70857 10.6785 4.59046C11.7554 3.47235 13.2237 2.81514 14.775 2.75693L15 2.75293H18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.75293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.01c846a8359d534c8b30c84489a83839.svg";
export { ForwardRef as ReactComponent };